export interface LatLng {
  lat: number;
  lng: number;
}

// Nakhon Pathom city center (fallback)
export const DEFAULT_CENTER: LatLng = { lat: 13.8196, lng: 100.0625 };

export function getCurrentLocation(timeoutMs = 10000): Promise<LatLng> {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new Error('อุปกรณ์ไม่รองรับการระบุพิกัด'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => reject(new Error(err.message || 'ไม่สามารถระบุพิกัดได้')),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 30000 },
    );
  });
}
